import './App.css';
import Header from './components/Header';
import Services from './components/Services';
import Home from './components/Home';

import { Router,Route,Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Aboutsus from './components/Aboutsus';
import Gallery from './components/Gallery';
import PatternDeisgn from './components/PatternDesign';
import Contact from './components/ContactUs';
import Quote from './components/Quote';

function App() {
  return (
    <>
      <Header />
      
        <div>
          <Routes>        
            <Route path="/"  element={ <Home /> } />
            <Route path="/aboutus"  element={<Aboutsus />}/>
            <Route path="/services"  element={<Services />}/>
            <Route path="/gallery"  element={<Gallery />}/>
            <Route path="/patterndesign"  element={<PatternDeisgn />}/>
            <Route path="/contact"  element={<Contact />}/>
            <Route path="/quote"  element={<Quote />}/>
          </Routes>
        </div>
      <Footer />
    </>
  );
}

export default App;
